import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const locSettings: Settings = {
  baseUrl: 'https://localhost:44382',
  environment: 'local',
  isProd: false,
  appInsightsConnectionString:
    'InstrumentationKey=b069f234-988b-4bfd-a9fc-b60fc58bd33c;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=825ea44c-21cb-4f7f-a69c-16d1e29bb062',
  msal: {
    config: {
      auth: {
        clientId: '018e09bd-0a75-43b8-809b-6f5cb863e5a9',
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01',
        redirectUri: 'http://localhost:4200/after-login',
        postLogoutRedirectUri: 'http://localhost:4200/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://localhost:44382', ['api://018e09bd-0a75-43b8-809b-6f5cb863e5a9/API.Call']]
      ])
    }
  }
};
